import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	movedColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	movedColumn: {
		id: 'native-issue-table.issue-table.header.moved-column',
		defaultMessage: 'You’ve moved {column} from {previousPosition} to {position} of {total}.',
		description: 'Screen reader announcement when a table column is moved to a new position',
	},
});
export default messages;
